export * from './authport.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader?keepUrl=true!./node_modules/tslint-loader!./src/authport/index.ts